import { cn } from 'src/lib/utils';
import { portalDs } from 'src/components/portal-design-system';

type SchedulerDsButtonVariant =
  | 'accent'
  | 'secondary'
  | 'ghost'
  | 'danger'
  | 'danger-ghost';

type SchedulerDsButtonSize = 'sm' | 'md';

const VARIANT_CLASSES: Record<SchedulerDsButtonVariant, string> = {
  accent: portalDs.btnAccent,
  secondary: portalDs.btnSecondary,
  ghost: portalDs.btnGhost,
  danger: 'border-[#DC2626] bg-[#DC2626] text-white hover:border-[#B91C1C] hover:bg-[#B91C1C]',
  'danger-ghost':
    'border-transparent bg-transparent text-[#DC2626] hover:bg-[#FEF2F2] hover:text-[#DC2626]',
};

const SIZE_CLASSES: Record<SchedulerDsButtonSize, string> = {
  sm: portalDs.btnSm,
  md: portalDs.btnMd,
};

export interface SchedulerDsButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: SchedulerDsButtonVariant;
  size?: SchedulerDsButtonSize;
}

/** Scheduler-only button matching design-system/design-system.html — do not use outside Operations scheduler. */
export function SchedulerDsButton({
  variant = 'secondary',
  size = 'md',
  className,
  type = 'button',
  ...props
}: SchedulerDsButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        portalDs.btnBase,
        VARIANT_CLASSES[variant],
        SIZE_CLASSES[size],
        className,
      )}
      {...props}
    />
  );
}

export const schedulerDsSegmentGroup =
  'inline-flex gap-0.5 rounded-lg bg-[#EDEEF2] p-[3px]';

export function schedulerDsSegmentButtonClass(active: boolean): string {
  return cn(
    'rounded px-3.5 py-[7px] text-[13px] font-semibold transition-all',
    active
      ? 'bg-white text-[#0D0F1A] shadow-[0_1px_2px_rgba(13,15,26,0.05)]'
      : 'bg-transparent text-[#5E6278] hover:text-[#0D0F1A]',
  );
}
